import axios from "axios";

export const convidar = (dados) => (axios.post('convite', dados));
export const buscarPorEmail = (email) => (axios.get(`convite?email=${email}`))
